import dayjs from 'dayjs';
import {
    parseAsArrayOf,
    parseAsFloat,
    parseAsInteger,
    parseAsString,
} from 'nuqs';

const NEWS_CALENDAR_DEFAULT_LIMIT = 50;

export const tradingJournalFiltersParser = {
    startDate: parseAsString,
    endDate: parseAsString,
};

export const patternLiveFiltersParser = {
    ticker: parseAsArrayOf(parseAsString),
    timeframe: parseAsArrayOf(parseAsString),
    threshold: parseAsArrayOf(parseAsFloat),
    unique_id: parseAsString,
    perc_min_rialzista: parseAsFloat,
    perc_max_rialzista: parseAsFloat,
    perc_min_ribassista: parseAsFloat,
    perc_max_ribassista: parseAsFloat,
    sort_by: parseAsString.withDefault('timestamp_start_subpattern_live'),
    sort_order: parseAsString.withDefault('desc' as const),
    limit: parseAsInteger.withDefault(5),
    offset: parseAsInteger.withDefault(0),
};

export const newsCalendarFiltersParser = {
    weekStart: parseAsString,
    day: parseAsString.withDefault(dayjs().format('YYYY-MM-DD')),
    month: parseAsString,
    currency: parseAsArrayOf(parseAsString),
    impactScore: parseAsArrayOf(parseAsInteger),
    category: parseAsArrayOf(parseAsString),
    search: parseAsString,
    limit: parseAsInteger.withDefault(NEWS_CALENDAR_DEFAULT_LIMIT),
    offset: parseAsInteger.withDefault(0),
};
